<div
  [class.max-h-0]="!expanded()"
  [class.max-h-[500px]]="expanded()"
  [class.py-4]="expanded()"
  [class.py-0]="expanded()"
  class="flex flex-col gap-4 w-full overflow-hidden transition-all duration-300 ease-in-out"
>
  <div class="flex flex-row items-center justify-between">
    <span class="pl-2 text-base font-semibold">{{ 'time-reports-filters.filters' | translate }}</span>
    <proffeo-ui-button
      (clicked)="onClose()"
      ariaLabel="close"
      fontIcon="close"
      variant="primary"
    />
  </div>
  <div class="grid grid-cols-2 gap-3">
    @for (filterConfig of filterConfigs(); track filterConfig.name) {
      @let state = getFilterState(filterConfig.name);
      <mat-form-field
        (click)="$event.preventDefault()"
        (menuOpened)="onMenuOpened(filterConfig.name)"
        (menuClosed)="onMenuClosed(filterConfig.name)"
        [matMenuTriggerFor]="dropdownMenu"
        class="w-full cursor-pointer"
      >
        <mat-label>{{ filterConfig.placeholder | translate }}</mat-label>
        <input
          [value]="getDisplayValue(filterConfig.name)"
          matInput
          readonly
          class="cursor-pointer truncate"
        />
        <mat-icon
          [class.rotate-180]="isMenuOpen(filterConfig.name)"
          fontIcon="arrow_drop_down"
          matSuffix
          class="transition-transform duration-200"
        />
      </mat-form-field>
      <mat-menu #dropdownMenu="matMenu">
        <div
          (click)="$event.stopPropagation()"
          class="flex flex-col overflow-hidden"
        >
          <div class="px-3 py-2">
            <proffeo-ui-input
              (keydown)="$event.stopPropagation()"
              (valueChange)="setSearch(filterConfig.name, $event)"
              [value]="getSearchTerm(filterConfig.name)"
              placeholder="placeholders.search-input"
              variant="search"
              class="w-full"
            />
          </div>
          <proffeo-ui-divider />
          @if (filterConfig.multiple) {
            <mat-checkbox
              (click)="toggleSelectAll(filterConfig.name)"
              [checked]="state.allSelected"
              [indeterminate]="state.someSelected"
              class="flex items-center cursor-pointer hover:bg-proffeo-surface-muted max-w-full overflow-hidden"
            >
              {{ 'placeholders.select-all' | translate }}
            </mat-checkbox>
            <proffeo-ui-divider />
          }
          <div class="max-h-60 overflow-y-auto overflow-x-hidden">
            @for (item of state.filteredItems; track item.value) {
              <mat-checkbox
                (click)="toggleOption(filterConfig.name, item.value)"
                [checked]="state.selectedSet.has(item.value)"
                [matTooltip]="item.label"
                class="block w-full cursor-pointer hover:bg-proffeo-surface-muted overflow-hidden"
              >
                <span class="block truncate">{{ item.label }}</span>
              </mat-checkbox>
            }
          </div>
        </div>
      </mat-menu>
    }
  </div>

  <div class="flex flex-row items-center justify-end gap-3 w-full">
    <proffeo-ui-button
      (clicked)="clearFilters()"
      text="time-reports-filters.clear-filters"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="onSearchClick()"
      text="time-reports-filters.search"
      variant="accent"
    ></proffeo-ui-button>
  </div>
</div>
